module.exports = __webpack_public_path__ + "img/Prog-final-Inperson-day3rms-v1.67b23750.svg";